import React, {useContext, useEffect, useState} from 'react';
import {isMobile} from 'react-device-detect';
import {LayerContext} from '../../../services/layer/layer.context';
import {DataContext} from '../../../services/data-v2/data.context';
import {BottomSheetCtx} from '../../../services/bottom-sheet/bottom-sheet-context';
import {ReactComponent as BiciVia} from '../../../assets/icons/bike-layer/bicivia.svg';
import {ReactComponent as InfoLine} from '../../../assets/icons/bike-layer/info_line.svg';
import './bikeNetwork-button.scss';

function BikeNetworkButtonComponent() {
    const LayerCtx = useContext(LayerContext);
    const {db} = useContext(DataContext);
    const {currentPosition} = useContext(BottomSheetCtx);
    const [bottom, setBottom] = useState<number>(87);

    useEffect(() => {
        setBottom(currentPosition);
    }, [currentPosition]);

    let styleButton = {};
    let styleInfo = {};
    const handleClick = () => {
        LayerCtx.toggleVisibleBikeLayer();
    };

    if (!isMobile) {
        styleButton = {
            'bottom': '305px',
            'right': '10px',
        } as React.CSSProperties;
        styleInfo = {
            'bottom': '335px',
            'right': '5px',
        } as React.CSSProperties;
    } else {
        styleButton = {
            'bottom': bottom+70,
            'right': '15px',
        } as React.CSSProperties;
        styleInfo = {
            'bottom': bottom+95,
            'right': '5px',
        } as React.CSSProperties;
    }
    return (
        <>
            {LayerCtx.visible && (

                db?.dataSources?.stops.slugFilter.BiciMap && (
                    <BiciVia
                        role="button"
                        className={LayerCtx.bikeLayerVisible ? 'opened transports-button' : 'closed transports-button'}
                        style={styleButton}
                        id="bikeNetworkButton"
                        onClick={handleClick}
                        onKeyPress={handleClick}
                        tabIndex={-20}
                    />
                )
            )}
            <div className={LayerCtx.visible && LayerCtx.activeFilters && db?.dataSources?.stops.slugFilter.BiciMap ? 'info-icon-opened' : 'info-icon-closed'}>
                <InfoLine style={styleInfo} className="info-icon" />
            </div>
        </>
    );
}
export default BikeNetworkButtonComponent;
